/* eslint-disable @typescript-eslint/no-explicit-any */
export default class BaseWalletService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  newChainHandler?: (chainId: number) => void;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  newNetworkHandler?: (networkId: number) => void;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  newAccountHandler?: (newAccounts: string) => void;

  disconnectHandler?: () => void;

  async init(
    newChainHandler?: (chainId: number) => void,
    newNetworkHandler?: (networkId: number) => void,
    newAccountHandler?: (newAccounts: string) => void,
    disconnectHandler?: () => void,
  ): Promise<void> {
    this.newChainHandler = newChainHandler;
    this.newNetworkHandler = newNetworkHandler;
    this.newAccountHandler = newAccountHandler;
    this.disconnectHandler = disconnectHandler;
  }

  disconnect = async (): Promise<void> => {
    this.handleDisconnect();
  };

  public getDownloadWalletPath = (): string => '';

  protected handleNewAccounts = (newAccounts: any) => {
    this.logInfo(newAccounts);
    if (this.newAccountHandler) {
      this.newAccountHandler(newAccounts);
    }
  };

  protected handleNewChain = (chainId: any) => {
    this.logInfo(chainId);

    if (this.newChainHandler) {
      if (chainId.toString().startsWith('0x')) {
        const chain: number = parseInt(chainId, 16);
        this.newChainHandler(chain);
      } else if (Number.isFinite(chainId)) {
        this.newChainHandler(chainId);
      }
    }
  };

  protected handleNewNetwork = (networkId: any) => {
    this.logInfo(networkId);
    if (this.newNetworkHandler) {
      this.newNetworkHandler(networkId);
    }
  };

  protected handleDisconnect = () => {
    if (this.disconnectHandler) {
      this.disconnectHandler();
    }
  };

  extractAccount = (accounts: string | string[]): string => (Array.isArray(accounts)
    ? accounts[0] : accounts);

  logError = (err: any) => {
    // eslint-disable-next-line no-console
    console.error(err);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  logInfo = (message: string) => {
    // eslint-disable-next-line no-console
    // console.warn(message);
  };
}
